var map = {
	"./assets/HomePreviewImages/About_Chao_Wang.jpg": [
		8666,
		1
	],
	"./assets/HomePreviewImages/Animation Reel.png": [
		5432,
		1,
		5432
	],
	"./assets/HomePreviewImages/Boy and the Fish.jpg": [
		2132,
		1,
		2132
	],
	"./assets/HomePreviewImages/Character Designs.png": [
		3799,
		1,
		3799
	],
	"./assets/HomePreviewImages/EFX Animation.png": [
		6628,
		1,
		6628
	],
	"./assets/HomePreviewImages/Get_In_Touch.PNG": [
		3325,
		1,
		3325
	],
	"./assets/HomePreviewImages/Location Designs.png": [
		1678,
		1,
		1678
	],
	"./assets/HomePreviewImages/Sketches.jpg": [
		3273,
		1,
		3273
	],
	"./assets/HomePreviewImages/Sound Designs.jpeg": [
		542,
		1,
		542
	],
	"./assets/HomePreviewImages/Story Boards.png": [
		8718,
		1,
		8718
	],
	"./assets/HomePreviewImages/background.png": [
		4088,
		1,
		4088
	],
	"./assets/HomePreviewImages/contact_profile.png": [
		2179,
		1
	],
	"./assets/HomePreviewImages/data": [
		5769,
		3
	],
	"./assets/HomePreviewImages/data.json": [
		5769,
		3
	],
	"./assets/Projects/2024_Wang_Wilson_Confinement_3.png": [
		4789,
		1,
		4789
	],
	"./assets/Projects/2024_Wang_Wilson_Confinement_5.png": [
		723,
		1,
		723
	],
	"./assets/Projects/39.jpg": [
		1839,
		1,
		1839
	],
	"./assets/Projects/BG_COLOR_SCENE24_v1.png": [
		7962,
		1,
		7962
	],
	"./assets/Projects/BG_Color31_V1.png": [
		8121,
		1,
		8121
	],
	"./assets/Projects/BG_LAYOUT_SCENE37_V2.png": [
		277,
		1,
		277
	],
	"./assets/Projects/Boy and the Fish.jpg": [
		9259,
		1,
		9259
	],
	"./assets/Projects/Character_ecpression_sheet.jpg": [
		3963,
		1,
		3963
	],
	"./assets/Projects/Cyber punk colored v2.jpg": [
		2528,
		1,
		2528
	],
	"./assets/Projects/Cyber punk.jpg": [
		1206,
		1,
		1206
	],
	"./assets/Projects/ED9ACE3C-0108-4D6C-996A-5FDFB7776D9D.jpg": [
		6968,
		1,
		6968
	],
	"./assets/Projects/FS Color Test.jpg": [
		9829,
		1,
		9829
	],
	"./assets/Projects/Forest Spirit Lineup.jpg": [
		665,
		1,
		665
	],
	"./assets/Projects/Forest Spitit Character Design.jpg": [
		1648,
		1,
		1648
	],
	"./assets/Projects/Fox Character Sheet.jpg": [
		4215,
		1,
		4215
	],
	"./assets/Projects/Girl Character sheet.jpg": [
		1120,
		1,
		1120
	],
	"./assets/Projects/Helios Final Character Design.png": [
		429,
		1,
		429
	],
	"./assets/Projects/Hidden forest lineart.jpg": [
		1711,
		1,
		1711
	],
	"./assets/Projects/Hidden forestc colored final.jpg": [
		6925,
		1,
		6925
	],
	"./assets/Projects/IMG_1730.JPG": [
		7021,
		1,
		7021
	],
	"./assets/Projects/IMG_4569.jpeg": [
		9791,
		1,
		9791
	],
	"./assets/Projects/IMG_4644.jpeg": [
		8454,
		1,
		8454
	],
	"./assets/Projects/IMG_5434.jpeg": [
		9384,
		1,
		9384
	],
	"./assets/Projects/IMG_5435.jpeg": [
		2203,
		1,
		2203
	],
	"./assets/Projects/IMG_5436.jpeg": [
		527,
		1,
		527
	],
	"./assets/Projects/IMG_5437.jpeg": [
		7335,
		1,
		7335
	],
	"./assets/Projects/IMG_5868.JPG": [
		333,
		1,
		333
	],
	"./assets/Projects/IMG_5869.JPG": [
		6296,
		1,
		6296
	],
	"./assets/Projects/IMG_5870.JPG": [
		3766,
		1,
		3766
	],
	"./assets/Projects/IMG_5871.JPG": [
		5499,
		1,
		5499
	],
	"./assets/Projects/IMG_6290.JPG": [
		3194,
		1,
		3194
	],
	"./assets/Projects/Matt lineup_v02.jpg": [
		3183,
		1,
		3183
	],
	"./assets/Projects/TH Color.jpg": [
		9021,
		1,
		9021
	],
	"./assets/Projects/TH_Mouth_Chart.JPG": [
		2932,
		1,
		2932
	],
	"./assets/Projects/The Mask scene 5 colored.jpg": [
		4160,
		1,
		4160
	],
	"./assets/Projects/The hallway Lineart.jpg": [
		9139,
		1,
		9139
	],
	"./assets/Projects/The hallway.jpg": [
		3625,
		1,
		3625
	],
	"./assets/Projects/Treasure Hunter Character Design.jpg": [
		9651,
		1,
		9651
	],
	"./assets/Projects/Treasure Hunter Lineup.jpg": [
		4552,
		1,
		4552
	],
	"./assets/Projects/TreasureHunter_Ex Sheet.jpg": [
		4594,
		1,
		4594
	],
	"./assets/Projects/Untitled_Artwork 29 copy 2.png": [
		5657,
		1,
		5657
	],
	"./assets/Projects/Untitled_Artwork 29 copy.png": [
		5082,
		1,
		5082
	],
	"./assets/Projects/Untitled_Artwork 29.png": [
		5817,
		1,
		5817
	],
	"./assets/Projects/Untitled_Artwork 30.png": [
		506,
		1,
		506
	],
	"./assets/Projects/Xavier expression sheet.jpg": [
		1513,
		1,
		1513
	],
	"./assets/Projects/Xavier lineup_v02.jpg": [
		5624,
		1,
		5624
	],
	"./assets/Projects/ancient temple Lineart.jpg": [
		1517,
		1,
		1517
	],
	"./assets/Projects/ancient temple.jpg": [
		4018,
		1,
		4018
	],
	"./assets/Projects/indexes/Animation Reel": [
		157,
		3,
		157
	],
	"./assets/Projects/indexes/Animation Reel.json": [
		157,
		3,
		157
	],
	"./assets/Projects/indexes/Character Designs": [
		2366,
		3,
		2366
	],
	"./assets/Projects/indexes/Character Designs.json": [
		2366,
		3,
		2366
	],
	"./assets/Projects/indexes/EFX Animation": [
		8010,
		3,
		8010
	],
	"./assets/Projects/indexes/EFX Animation.json": [
		8010,
		3,
		8010
	],
	"./assets/Projects/indexes/Location Designs": [
		1963,
		3,
		1963
	],
	"./assets/Projects/indexes/Location Designs.json": [
		1963,
		3,
		1963
	],
	"./assets/Projects/indexes/Sketches": [
		4740,
		3,
		4740
	],
	"./assets/Projects/indexes/Sketches.json": [
		4740,
		3,
		4740
	],
	"./assets/Projects/indexes/Sound Designs": [
		3333,
		3,
		3333
	],
	"./assets/Projects/indexes/Sound Designs.json": [
		3333,
		3,
		3333
	],
	"./assets/Projects/indexes/Story Boards": [
		1058,
		3,
		1058
	],
	"./assets/Projects/indexes/Story Boards.json": [
		1058,
		3,
		1058
	],
	"./assets/icons/Logo Light.PNG": [
		7626,
		1
	],
	"./assets/icons/Logo-Light.ico": [
		2540,
		1,
		2540
	],
	"./assets/icons/instagram.svg": [
		673,
		1,
		673
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3383;
module.exports = webpackAsyncContext;